import { ConfigService } from './../../services/config/config.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from '../../services/apiservice/apiservice.service';
import { StorageService } from '../../services/storage/storage.service';
import { SearchService } from '../../services/search/search.service';
import { SharedService } from '../../services/shared/shared.service';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';
import { throwError } from 'rxjs';
import { Library } from '../../core/interfaces/library.interface';
import { ApiResponse } from '../../services/api-response.interface';

export interface LibraryLookupToolResponse {
  active: boolean;
  errorMessage: string;
  patronLookupToolRequiresPin: boolean;
  libraries: Library[];
}

@Injectable()
export class PatronLookupService {
  userData$: BehaviorSubject<any> = new BehaviorSubject(null);
  token$: BehaviorSubject<any> = new BehaviorSubject(null);
  intermediate$: BehaviorSubject<any> = new BehaviorSubject(null);
  private key2 = 'userData';
  private token = '';
  private userData: any;
  url = '';

  constructor(
    private _apiService: ApiService,
    private _authService: AuthService,
    private _configService: ConfigService,
    private _searchService: SearchService,
    private _sharedService: SharedService,
    private _storageService: StorageService,
  ) {}

  getLibraries(value): Observable<ApiResponse<Library[]>> {
    this.url = this._configService.agApi + '/patronlookup/getlibraries/' + value;
    return this._apiService.get<ApiResponse<Library[]>>(this.url).pipe(
      catchError((err: unknown) => {
        return throwError(err);
      }),
    );
  }

  getInfo(): Observable<ApiResponse<LibraryLookupToolResponse>> {
    this.url = this._configService.agApi + '/patronlookup/getinfo';
    return this._apiService.get<ApiResponse<LibraryLookupToolResponse>>(this.url).pipe(
      map((res) => res),
      catchError((err: unknown) => {
        return throwError(err);
      }),
    );
  }

  postCheck(data): Observable<any> {
    this.url = this._configService.agApi + '/patronlookup/check';
    return this._apiService.post(this.url, data).pipe(
      catchError((err: unknown) => {
        return throwError(err);
      }),
    );
  }

  getIntermediateBS() {
    return this.intermediate$.asObservable();
  }

  setIntermediateBS(value) {
    this.intermediate$.next(value);
  }
}
